/** @jsxImportSource @emotion/react */
import React, { useMemo, useRef, useState } from 'react';
import PropTypes, { any } from 'prop-types';
import { GlobalBtnGroup, SubTitleGroup, SubTitleLayout } from 'components/layouts/ContentLayout';
import { Button } from '@mui/material';
import { IconButton } from 'components/buttons/IconSVG';
import CustomGrid from 'components/grids/CustomGrid';
import { useTranslation } from 'react-i18next';

const DtlIsptMatr = (props) => {
  const { t } = useTranslation();

  const gridRef = useRef();
  const [rowData, setRowData] = useState<any>([]);

  const layoutDefinition = useMemo(() => {
    return [
      {
        binding: 'bildPlntCdNm',
        header: String(t('com.label.구분', '구분')),
        align: 'center',
        minWidth: 40,
        width: 100,
      },
      {
        binding: 'custNm',
        header: String(t('com.label.상세 점검사항', '상세 점검사항')),
        align: 'center',
        minWidth: 40,
        width: 180,
      },
      {
        binding: 'custNm',
        header: String(t('com.label.설비군', '설비군')),
        align: 'center',
        minWidth: 40,
        width: 200,
      },
      {
        binding: 'custNm',
        header: String(t('com.label.투자항목', '투자항목')),
        align: 'center',
        minWidth: 40,
        width: 180,
      },
      {
        binding: 'custNm',
        header: String(t('com.label.단가기준', '단가기준')),
        align: 'center',
        minWidth: 40,
        width: '*',
      },
      {
        binding: 'custNm',
        header: String(t('com.label.비고', '비고')),
        align: 'center',
        minWidth: 40,
        width: '*',
      },
      {
        binding: 'elmPrjNm',
        header: String(t('com.label.수정자', '수정자')),
        align: 'center',
        minWidth: 40,
        width: 120,
      },
      {
        binding: 'elmPrjId',
        header: String(t('com.label.수정일자', '수정일자')),
        align: 'center',
        minWidth: 40,
        width: 120,
      },
    ];
  }, [rowData]);

  const onInitialized = (grid) => {
    gridRef.current = grid;
  };

  return (
    <>
      <SubTitleLayout>
        <SubTitleGroup>
          <h3>{t('setup.label.상세 점검사항', '상세 점검사항')}</h3>
          <span className="total">
            {t('com.label.총', '총')}
            <span>{(rowData || []).length.toLocaleString()}</span>
            {t('com.label.건', '건')}
          </span>
        </SubTitleGroup>
        <GlobalBtnGroup>
          <Button css={IconButton.button} className="icoNone" disableRipple onClick={(e) => null}>
            {t('com.button.미사용', '미사용')}
          </Button>
          <Button css={IconButton.button} className="icoNone" disableRipple onClick={(e) => null}>
            {t('com.button.추가', '추가')}
          </Button>
          <Button css={IconButton.button} className="icoNone" disableRipple onClick={(e) => null}>
            {t('com.button.수정', '수정')}
          </Button>
          <Button css={IconButton.button} className="icoNone" disableRipple onClick={(e) => null}>
            {t('com.button.삭제', '삭제')}
          </Button>
          <Button css={IconButton.button} className="save" onClick={(e) => null}>
            {t('com.label.저장', '저장')}
          </Button>
        </GlobalBtnGroup>
      </SubTitleLayout>
      <CustomGrid
        layoutDefinition={layoutDefinition}
        rowData={rowData}
        isReadOnly={true}
        allowPinning={false}
        initialized={onInitialized}
        height={510}
      />
    </>
  );
};

DtlIsptMatr.propTypes = {
  condition: any,
};

export default DtlIsptMatr;
